import styled from '@emotion/styled';
import { Button } from '@mantine/core';
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { mediaQueryTablet } from '~/styles/mixins';

import UpraisedLogo from '~/assets/companyLogos/upraised.svg';

const Root = styled.nav`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;
  height: 64px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  ${mediaQueryTablet} {
    padding: 0 16px;
  }
`;

const LogoLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  height: 64px;
  padding: 16px 0;
  > svg {
    flex-shrink: 0;
    height: 100%;
  }
`;

const SignupButton = () => {
  const [search] = useSearchParams();
  search.set('next_path', window.location.pathname + '?' + window.location.search);
  const searchString = search.toString();
  return (
    <Button
      ml="auto"
      color="orange"
      radius="50px"
      size="sm"
      variant="outline"
      component={Link}
      to={'/signup?' + searchString}
    >
      Signup
    </Button>
  );
};

const AnonoymousNavbar = ({ rightComponent = <SignupButton /> }) => {
  return (
    <>
      <Root>
        <Content>
          <LogoLink to="/">
            <UpraisedLogo />
          </LogoLink>
          {rightComponent}
        </Content>
      </Root>
    </>
  );
};

export default AnonoymousNavbar;
